import { Delete } from '@mui/icons-material';
import { useMemo } from 'react';
import {
  DateField,
  EditButton,
  SimpleShowLayout,
  TextField,
  UpdateButton,
  useGetIdentity,
  useRecordContext,
} from 'react-admin';

export const AppGlobalAlertsCommandPanel = () => {
  const record = useRecordContext();

  const userId = useGetIdentity().data?.id?.toString();

  const archiveData = useMemo(
    () => ({
      archivedAt: new Date(),
      archivedBy: userId,
    }),
    [userId],
  );

  const unarchiveData = useMemo(
    () => ({
      archivedAt: null,
      archivedBy: userId,
    }),
    [userId],
  );

  return (
    <SimpleShowLayout record={record}>
      <TextField source="id" />
      <TextField source="singleLineDescription" />
      <TextField source="title" />
      {!record.archivedAt && (
        <>
          <EditButton label="Edit" />
          <UpdateButton
            mutationMode="pessimistic"
            style={{ marginLeft: '1rem' }}
            confirmTitle="Are you sure?"
            confirmContent="This will archive this Alert and will no longer be visible to Users"
            label="Archive"
            icon={<Delete />}
            data={archiveData}
          />
        </>
      )}
      {record.archivedAt && (
        <>
          <DateField source="archivedAt" showTime />
          <UpdateButton
            style={{ marginLeft: '1rem' }}
            label="Unarchive"
            mutationMode="pessimistic"
            confirmTitle="Are you sure?"
            confirmContent="This will unarchive this Alert and become visible to all Users"
            data={unarchiveData}
          />
        </>
      )}
    </SimpleShowLayout>
  );
};
